var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerateCertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.13759 6.86221C8.16562 5.89024 6.58974 5.89024 5.61777 6.86221L3.12888 9.3511C2.15691 10.3231 2.15691 11.899 3.12888 12.8709C4.10085 13.8429 5.67673 13.8429 6.6487 12.8709L7.33412 12.1855M6.86221 9.13759C7.83419 10.1096 9.41006 10.1096 10.382 9.13759L12.8709 6.6487C13.8429 5.67673 13.8429 4.10085 12.8709 3.12888C11.899 2.15691 10.3231 2.15691 9.3511 3.12888L8.6669 3.81308",
    stroke: "#6366F1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateCertIcon);
export default __webpack_public_path__ + "static/media/generate-cert-icon.3d374ccbdc1c9281fb3cae03a742ff08.svg";
export { ForwardRef as ReactComponent };